import { createFileRoute } from '@tanstack/react-router';
import { TestPlanList } from '@/features/qa/TestPlanList';

/** Lista delle campagne di collaudo (`test-plans`). */
export const Route = createFileRoute('/_app/test-plans/')({ component: TestPlanList });
